<template>
    <Background
        :backPath="'/home'">

        <a-input-search
            v-model="searchContent"
            size="large"
            placeholder="搜索商户"
            class="search"
            @search="onSearch"
        />

        <div class="search-hint-area">
            <div
                v-if="searching"
                class="search-hint">
                <div class="search-content">
                    搜索到{{ searchNumber }}条
                </div>
                <div
                    v-on:click="cleanSearch"
                    class="clean-search">
                    清空搜索 <a-icon type="close" />
                </div>
            </div>
        </div>

        <ListView
            v-if="searching"
            ref="searchList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :clickCallback="clickUser"
            :listWidth="80"
        />
        <ListView
            v-else
            ref="userList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :fetchCallback="fetchUserList"
            :clickCallback="clickUser"
            :addCallback="addUser"
            :listWidth="80"
        />

        <div
            v-if="amount > 0"
            class="merchant-amount">
            商家总数: {{ amount }}
        </div>

        <AddMerchantDialog ref="dialog"/>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import ListView from "./ListView.vue"
 import AddMerchantDialog from "./AddMerchantDialog.vue"

 import InputSearch from "ant-design-vue/lib/input/Search";

 import { isEmptyOrWhitespace } from "../util/utils.js"

 Vue.component(InputSearch.name, InputSearch);

 export default {
     name: 'MerchantManage',
     data() {
         return {
             amount: 0,
             searchContent: "",
             searchNumber: 0,
             searching: false,
             titles: ["老板电话", "老板名字", "商户简称", "企业全称", "微信商户号", "微信支付模板号"],
             columnWidths: [15, 20, 20, 20, 15, 10],
             columnCells: [
                 { value: "Phone",
                   style: ""
                 },
                 { value: "Username",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "Shop.ShopName",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "Shop.CompanyName",
                   style: "text-align: start; padding-left: 10px;"
                 },
                 { value: "Shop.WxMchId",
                   style: "text-align: end; padding-right: 20px;"
                 },
                 { value: "Shop.WxPlanId",
                   style: "text-align: end; padding-right: 20px;"
                 },
             ]
         }
     },
     components: {
         Background,
         ListView,
         AddMerchantDialog
     },
     computed: {
     },
     mounted() {
         this.fetchAmount()
     },
     methods: {
         fetchAmount() {
             const url = `${process.env.VUE_APP_API_SERVER}/business/total`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response.Total) {
                     this.amount = response.Total
                 } else {
                     console.log("fetchAmount error: ", response)
                 }
             })
         },
         clickUser(item) {
             sessionStorage.setItem("clickMerchantInfo", JSON.stringify(item))

             this.$router.push("/merchantInfo")
         },
         addUser() {
             this.$refs.dialog.show()
         },
         fetchUserList(offset, callback) {
             const url = `${process.env.VUE_APP_API_SERVER}/business?offset=${offset}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                  console.log("Error: ", error)
             }).then(response => {
                 console.log(response)

                 callback(response)
             })
         },
         onSearch() {
             this.searching = !isEmptyOrWhitespace(this.searchContent)

             if (this.searching) {
                 this.doSearch()
             }
         },
         doSearch() {
             const url = `${process.env.VUE_APP_API_SERVER}/business/search?q=${this.searchContent}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response) {
                     this.searchNumber = response.length
                     this.$refs.searchList.initList(response)
                 } else {
                     this.searchNumber = 0
                     this.$refs.searchList.initList([])
                 }
             })
         },
         cleanSearch() {
             this.searching = false
             this.searchContent = ""
             this.searchNumber = 0

             var that = this
             setTimeout(function () {
                 that.$refs.userList.research()
             }, 100)
         }
     },
 }
</script>

<style scoped>
 .search {
     width: 400px;
 }

 .search-hint-area {
     height: 50px;
 }

 .search-content {
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     color: #666;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .search-hint {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
 }

 .clean-search {
     background-color: #F9D878;
     color: #666;
     font-size: 16px;
     border-radius: 5px;
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     cursor: pointer;
 }

 .merchant-amount {
     width: 100%;
     margin-top: 10px;
     color: #AAA;
 }
</style>
